import { useTranslation } from "react-i18next";
import Constants from "../../Constants";
import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import DatePickerCalendar from "../../components/dashboard/calendars/DatePickerCalendar";
import dateUtil from "../../services/DateUtil";
import { calenderIcon } from "../../AppIcons";
import { putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { ConditionalBlock } from "../../ConditionalBlock";
import moment from "moment-timezone";
import $ from "jquery";
import { getTimeStamp, transformBlankToNull, utcTimeStamp } from "../../services/Util";
import i18next from "i18next";


export default function PaymentStatusTab(prop) {

  const { t } = useTranslation();
  const translate = t;
  const refToggle = useRef(null);
  const refCalendar = useRef(null);
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [subscriberInvoiceStatus, setSubscriberInvoiceStatus] = useState();
  const [vendorInvoiceStatus, setVendorInvoiceStatus] = useState();
  const [subscriberInvoiceNumber, setSubscriberInvoiceNumber] = useState();
  const [vendorInvoiceNumber, setVendorInvoiceNumber] = useState();
  const [toggle, toggleCal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [date, setDate] = useState();
  const [isCancelButtonClicked, setIsCancelButtonClicked] = useState(true);
  const [billingRecordsInclusionDate, setBillingRecordsInclusionDate] = useState();
  const [showReverificationPopup, setShowReverificationPopup] = useState(false);
  const [includeInBillingRecords, setIncludeInBillingRecords] = useState(false);

  const subscriberBillingStatusMap = new Map([
    [
      Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action,
      translate("subscriber_invoice_status.CUSTOMER_INVOICE_NO_ACTION"),
    ],
    [
      Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_sent,
      translate("subscriber_invoice_status.CUSTOMER_INVOICE_SENT"),
    ],
    [
      Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_paid,
      translate("subscriber_invoice_status.CUSTOMER_INVOICE_PAID"),
    ],
  ]);

  const serviceProviderBillingStatusMap = new Map([
    [
      Constants.SERVICE_PROVIDER_INVOICE_STATUS.vendor_invoice_no_action,
      translate("service_provider_invoice_status.VENDOR_INVOICE_NO_ACTION"),
    ],
    [
      Constants.SERVICE_PROVIDER_INVOICE_STATUS.vendor_invoice_received,
      translate("service_provider_invoice_status.VENDOR_INVOICE_RECEIVED"),
    ],
    [
      Constants.SERVICE_PROVIDER_INVOICE_STATUS.vendor_invoice_paid,
      translate("service_provider_invoice_status.VENDOR_INVOICE_PAID"),
    ],
  ]);


  useEffect(() => {
    if(isCancelButtonClicked){
    setVendorInvoiceStatus({
      value: prop?.data?.vendorBillingStatus,
      label: serviceProviderBillingStatusMap.get(prop?.data?.vendorBillingStatus),
    });

    setSubscriberInvoiceStatus({
      value: prop?.data?.customerBillingStatus,
      label: subscriberBillingStatusMap.get(prop?.data?.customerBillingStatus),
    });

    setSubscriberInvoiceNumber(prop?.data?.customerInvoiceNumber);
    setVendorInvoiceNumber(prop?.data?.vendorInvoiceNumber);

    setDate(prop?.data?.customerPaidDate ? new Date(moment(prop?.data?.customerPaidDate.utcTimestamp).format("MM/DD/YYYY")) : null);
    setIncludeInBillingRecords(prop?.data?.billingInclusionDate !== "");
    setBillingRecordsInclusionDate(prop?.data?.billingInclusionDate ? prop?.data?.billingInclusionDate?.utcTimestamp : null);
    setIsCancelButtonClicked(false);
    setIsDataChanged(false);

  }
  }, [isCancelButtonClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if ( refCalendar.current && !refCalendar.current?.contains(event.target) && !refToggle.current?.contains(event.target)) {
        toggleCal(false);
      }
    }

    document.addEventListener("click", handleClickOutside, true);

    $.each($('.react-calendar__tile'), function( index, value ) {
        $(value).attr('aria-label', value.children[0].ariaLabel);
    });

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [refCalendar]);

  const subscriberBillingStatusArray = Array.from(
    subscriberBillingStatusMap,
    ([value, label]) => ({
      value,
      label,
    })
  );

  const serviceProviderBillingStatusArray = Array.from(
    serviceProviderBillingStatusMap,
    ([value, label]) => ({
      value,
      label,
    })
  );

  const fieldChange = (event) => {
    if (event?.target?.value.match(/^[a-zA-Z0-9\/\-\ ]*$/)) {
      if (event?.target?.name === "customer_invoice_num") {
        setSubscriberInvoiceNumber(event.target.value);
        setIsDataChanged(true);
      }
      if (event?.target?.name === "vendor_invoice_num") {
        setVendorInvoiceNumber(event.target.value);
        setIsDataChanged(true);
      }
    }
  };

  const saveDetails = () => {
    let data = { id: prop.data.projectId };

    if (subscriberInvoiceStatus) {
      data = { ...data, customerBillingStatus: subscriberInvoiceStatus?.value };
    }
    if (vendorInvoiceStatus) {
      data = { ...data, vendorBillingStatus: vendorInvoiceStatus?.value };
    }
    if (subscriberInvoiceNumber) {
      data = { ...data, customerInvoiceNumber: subscriberInvoiceNumber };
    }
    if (vendorInvoiceNumber) {
      data = { ...data, vendorInvoiceNumber: vendorInvoiceNumber };
    }
    if (date) {
      let customer_paid_date = { utcTimestamp: date.getTime() };
      data = { ...data, customerPaidDate: customer_paid_date };
    }
    if (billingRecordsInclusionDate) {
      let billingDate = getTimeStamp(billingRecordsInclusionDate);
      data = { ...data, billingInclusionDate: billingDate };
    }

    data = transformBlankToNull(data);

    putAxiosResponse(APIUrls.PROJECT_LIST_FINANCE, data).then((res) => {
      setShowSuccessMsg(true);
      closePopupBox();
      setIsDataChanged(false);
      prop.setPaymentDataChanged(true);
    });
  };

  function showPopupBox() {
    if (isDataChanged) {
      setShowPopup(true);
      document.body.classList.add("modal-open");
    }
  }
  function closePopupBox() {
    setShowPopup(false);
    document.body.classList.remove("modal-open");
  }

  const closeReverificationPopup = () => {
    setShowReverificationPopup(false);
    document.body.classList.remove("modal-open-7");
  };

  const confirmInclusionInBillingRecords = () => {
    const currentDate = utcTimeStamp(new Date(), Constants.TIMEZONE_PST);
    setIncludeInBillingRecords(true);
    setShowReverificationPopup(false);
    setBillingRecordsInclusionDate(currentDate);
    setIsDataChanged(true);
    document.body.classList.remove("modal-open-7");
  }

  useEffect(() => {
    if (showSuccessMsg) {
      setTimeout(function () {
        setShowSuccessMsg(false);
      }, 2000);
    }
  }, [showSuccessMsg]);

  const closeCalendar = (e) => {
    if (e.code === Constants.ESCAPE) {
        toggleCal(false);
    }
  }

  const calculateRemainingCharacters = (input) => {
    const remainingCharacters = 32 - (input?.length || 0);
    const isLimitExceeded = remainingCharacters === 0 || isNaN(remainingCharacters);
    return { remainingCharacters, isLimitExceeded };
  };

  const customerInvoiceNumberValidations = calculateRemainingCharacters(subscriberInvoiceNumber);
  const vendorInvoiceNumberValidations = calculateRemainingCharacters(vendorInvoiceNumber);

  const selectionReverification = (e) => {
    if (e.target.checked) {
      setShowReverificationPopup(true);
      document.body.classList.add("modal-open-7");
    } else {
      setIncludeInBillingRecords(false);
      setIsDataChanged(true);
      setBillingRecordsInclusionDate(null);
    }
  }

  const isProjectClosed = prop?.data?.closeDate !== "" && prop?.data?.projectStatus === Constants.PROJECT_CLOSED;
  const isOutlier = prop?.data?.closeDate === "" || prop?.data?.projectStatus !== Constants.PROJECT_CLOSED;


  return (
    <>
    <div id="content" className="dashboard-wrap campaign-section">
      <div className="listing-content">
        <div className="project-information">
          <h6>{t("finance.payment_status")}</h6>
          <div className="translation-summary">
            <div className="project-table">
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.customer_invoice_status")}</div>
                  <div className="global-dropdown-block mar-bot14 ">
                    <Select
                      classNamePrefix="cw"
                      styles={{
                        option: (baseStyles, state) => ({
                          ...baseStyles,
                          color: aaaSelected ? "#000000" : "#1C233C",
                        }),
                      }}
                      name="customer billing status"
                      aria-label="customer billing status"
                      placeholder={"Please Select"}
                      options={subscriberBillingStatusArray}
                      onChange={(value) => {setSubscriberInvoiceStatus(value);  setIsDataChanged(true);}}
                      value={subscriberBillingStatusArray.filter(
                        (option) =>
                          option.label === subscriberInvoiceStatus?.label
                      )}
                    ></Select>
                  </div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.vendor_invoice_status")}</div>
                  <div className="global-dropdown-block mar-bot14">
                    <Select
                      classNamePrefix="cw"
                      styles={{
                        option: (baseStyles, state) => ({
                          ...baseStyles,
                          color: aaaSelected ? "#000000" : "#1C233C",
                        }),
                      }}
                      name="vendor billing status"
                      aria-label="vendor billing status"
                      placeholder={"Please Select"}
                      options={serviceProviderBillingStatusArray}
                      onChange={(value) => {setVendorInvoiceStatus(value); setIsDataChanged(true);}}
                      value={serviceProviderBillingStatusArray.filter(
                        (option) => option.label === vendorInvoiceStatus?.label
                      )}
                    ></Select>
                  </div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.subscriber_invoice_number")}</div>
                  <input
                    autoComplete="off"
                    maxLength="32"
                    placeholder="Invoice #"
                    name="customer_invoice_num"
                    value={subscriberInvoiceNumber}
                    type="text"
                    onChange={(e) => fieldChange(e)}
                    className="form-control form-control-sm width-auto"
                    title="Subscriber Invoice Number"
                    required
                  />
                  <div className={`${customerInvoiceNumberValidations.isLimitExceeded ? "error-alert " : ""}mar-left-10 mar-top10`}>
                    {isNaN(customerInvoiceNumberValidations.remainingCharacters) ? 32 : customerInvoiceNumberValidations.remainingCharacters} characters left
                  </div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.service_provider_invoice_number")}</div>
                  <input
                    autoComplete="off"
                    maxLength="32"
                    placeholder="Invoice #"
                    name="vendor_invoice_num"
                    value={vendorInvoiceNumber}
                    type="text"
                    onChange={(e) => fieldChange(e)}
                    className="form-control form-control-sm width-auto"
                    title="SP Invoice Number"
                    required
                  />
                  <div className={`${vendorInvoiceNumberValidations.isLimitExceeded ? "error-alert " : ""}mar-left-10 mar-top10`}>
                  {isNaN(vendorInvoiceNumberValidations.remainingCharacters) ? 32 : vendorInvoiceNumberValidations.remainingCharacters} characters left
                  </div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns last-row">
                  <div className="title">{t("finance.subscriber_paid_date")}</div>
                  <div className="flex wrap-dropdown">
                    <div className="global-dropdown-block calender100 flex-center">
                      <div className="flex-center w-d100 p-relative">
                      <div className="global-dropdown-select">
                        <button onClick={(e) => { toggleCal(!toggle); }} ref={refToggle} aria-expanded={toggle ? "true" : "false"} id="cal-secondFocus" tabIndex={0}
                          required type="button" className="drop-down-btn gb-dropBtn cal-secondFocus"
                          aria-label={ date !== "" ? ` Campaign due date ${dateUtil.format(date, "MM/DD/YY", null )} selected` : ""} >
                          <span>
                            {date !== ""
                              ? dateUtil.format(date, "MM/DD/YY", null)
                              : ""}
                          </span>
                          <span className="font-zero">
                            {date !== ""
                              ? dateUtil.format(date, "MM/DD/YY", null)
                              : "Campaign due date"}
                          </span>
                          {calenderIcon}
                        </button>
                      </div>
                      {toggle ? (
                        <div ref={refCalendar} onKeyDown={(e) => { closeCalendar(e); }}>
                          <DatePickerCalendar value={date} className="dueCalendar"
                            selectDate={(e) => { 
                              toggleCal(!toggle);
                              setDate(e);
                              setIsDataChanged(true);
                            }}
                          /></div>
                        ) : ( "" )}
                      </div>
                    </div>
                  </div>
                </li>
                <li className="finance-columns last-row height76">
                  <div className="title">{t("finance.include_in_billing_records")}</div>
                  <input type="checkbox" disabled={isProjectClosed} checked={isProjectClosed || includeInBillingRecords}
                    onChange={isOutlier ? selectionReverification : undefined}
                  />
                </li>
              </ul>
            </div>
          </div>

          <ConditionalBlock condition={showPopup}>
            <div id="modelPopup" className="lightbox-panel approved-popup" aria-labelledby="approveTranslated" aria-modal="true" role="dialog" >
              <div className="inner-lightbox-panel">
                <div className="modal-header flex">
                  <strong id="approveTranslated">{t("finance.save_changes")}</strong>
                </div>
                <div className="lightbox-content">
                  <p>{t("finance.confirm_msg")}</p>
                </div>
                <div className="modal-footer flex">
                  <button className="btn btn-bold active" onClick={saveDetails}>
                  {t("button_save")}
                  </button>
                  <button className="btn btn-bold" onClick={closePopupBox}>
                  {t("button_cancel")}
                  </button>
                </div>
              </div>
            </div>
          </ConditionalBlock>
          <ConditionalBlock condition={showReverificationPopup}>
            <div id="modal-open-7" className="lightbox-panel approved-popup" aria-labelledby="approveTranslated" aria-modal="true" role="dialog" >
              <div className="inner-lightbox-panel">
                <div className="modal-header flex">
                  <strong id="approveTranslated">{t("finance.reverification_header")}</strong>
                </div>
                <div className="lightbox-content">
                <p dangerouslySetInnerHTML={{ __html: i18next.t('finance.reverification_msg', { 0: prop?.data?.projectName }) }}></p>
                </div>
                <div className="modal-footer flex">
                  <button className="btn btn-bold" onClick={closeReverificationPopup}>
                    {t("button_cancel")}
                  </button>
                  <button className="btn btn-bold active" onClick={confirmInclusionInBillingRecords}>
                    {t("finance.confirm")}
                  </button>
                </div>
              </div>
            </div>
          </ConditionalBlock>
          <ConditionalBlock condition={showSuccessMsg}>
            <div className={"success-message show"} id="show-success" role="alert" >
              {`${t("finance.payment_details_update_success")}`}
            </div>
          </ConditionalBlock>
        </div>
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
          <div>
            <button type="button" className="btn-default" onClick={(e) => setIsCancelButtonClicked(true)}>
              {t("button_cancel")}
            </button>
          </div>
          <div>
            <button className="btn " onClick={showPopupBox}>
              {t("button_save")}
            </button>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}
